import { render, staticRenderFns } from "./style-guide.vue?vue&type=template&id=9157f290&"
import script from "./style-guide.vue?vue&type=script&lang=js&"
export * from "./style-guide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports